import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewMoreComponent } from './view-more.component';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    ViewMoreComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports:[
    ViewMoreComponent
  ]
})
export class ViewMoreModule { }
